import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { DictionaryService } from 'src/app/core/service/dictionary.service';
import { MessageHandlerService } from 'src/app/core/utility/message-handler.service';
import { sortBy } from 'lodash';

@Component({
  standalone: false,
  selector: 'app-formly-field-select',
  templateUrl: './formly-field-select.component.html',
  styleUrls: ['./formly-field-select.component.scss']
})
export class FormlyFieldSelectComponent extends FieldType
{
  public dictionary = undefined;

  constructor(
    private dictionaryService: DictionaryService,
    private messageHandlerService: MessageHandlerService)
  {
    super();
    setTimeout(() =>
    {
      this.dictionary = undefined;
      if (this.field && this.field.templateOptions && this.field.templateOptions.codeSetId) 
      {
        this.dictionaryService.getCachedCodesByCodeSetId(this.field.templateOptions.codeSetId).subscribe({
          next: (data) =>
          {
            this.dictionary = sortBy(data, ['displayName']);
            // Must call set value to make sure the display name is shown
            this.formControl.setValue(this.formControl.value);
            this.formControl.updateValueAndValidity();
          },
          error: (error) =>
          {
            this.messageHandlerService.displayError(error);
          }
        });
      }
    });
  }
}
